module.exports = "/static/assets/ab94bce18038d46772c4c013b18c50d8.png";